import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Drawer,
  ListItemIcon,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState, useEffect, useMemo } from "react";

import NoteIcon from "../../../assets/images/notelIcon.svg";
import MinimizeIcon from "../../../assets/images/minimizeIcon.svg";
import DashboardIcon from "../../../assets/images/dashboard.svg";
import PinIcon from "../../../assets/images/pin-icon.svg";
import BookmarkIcon from "../../../assets/images/bookmark.svg";
import PinnedPromptsDialog from "./PinnedPromptsDialog";
import BookmarkChatsDialog from "./BookmarkChatsDialog";
import RecentIcon from "../../../assets/images/recent.svg";
import MenuIcon from "../../../assets/images/menu.svg";
import DeleteChatDialog from "./DeleteChatDialog";
import {
  bookmarked,
  renameConversationV2,
  unBookmarked,
  deleteConversation,
} from "Samarth Module/api/samarthAiAPI";
import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "../../../assets/images/deleteIcon.svg";
import FilledBookmarkIcon from "../../../assets/images/fillBookmarked.svg";
import ReusableSnackbar from "./ReusableSnackbar";
const smallIconStyle = {
  height: { xs: "16px", md: "24px", lg: "32px" },
  width: { xs: "16px", md: "24px", lg: "32px" },
  borderRadius: "50%",
  transition: "all 0.3s",
  cursor: "pointer",
  "&:hover": {
    background: "#C2E0FF",
  },
};
const size = {
  sm: 16,
  md: 18,
  lg: 20,
};

const chatItemStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  py: 0.75,
  px: 1,
  borderRadius: "8px",
  cursor: "pointer",
  mb: 0.5,
  fontSize: { xs: "8px", md: "10px", lg: "14px" },
  lineHeight: "1.4",
  color: "#667F93",
  "&:hover .menuBtn": { opacity: 1 },
  "&:hover": { background: "#F0F7FF", color: "#0066CC" },
  "& .MuiInputBase-root": {
    fontSize: { xs: "8px", md: "10px", lg: "14px" },
    lineHeight: "140%",
  },
  "& .MuiInputBase-input": {
    p: 0,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "transparent !important",
  },
};


const OptionLabel = {
  color: "#667F93",
  fontSize: { xs: "8px", md: "10px", lg: "14px" },
  lineHeight: "140%",
  transition: "all 0.5s",
};
const menuOptions = {
  cursor: "pointer",
  p: { xs: "4px", md: "12px", lg: "16px" },
  transition: "all 0.5s",
  borderRadius: "8px",
  "&:hover": {
    background: "#F0F7FF",
  },
};
const recentChats = {
  background: "transparent",
  m: '0 !important',
  '&.Mui-expanded': {
    '& .MuiAccordionSummary-content': {
      '& .MuiTypography-body1': {
        color: '#0066CC',
        fontWeight: 600,
      }
    },

  },
  '&:before': {
    display: 'none'
  },
  '& .MuiButtonBase-root': {
    cursor: 'pointer', p: 2, mb: '14px', transition: 'all 0.5s', borderRadius: '8px', minHeight: 'auto !important',
    '&:hover': {
      background: '#F0F7FF',
    },
    '& .MuiAccordionSummary-content': {
      m: '0 !important'
    },
  },
  '& .MuiAccordionDetails-root': {
    p: '0 0 0 52px'
  },

}

const MenuStyles = {
  "& .MuiMenu-paper": {
    background: "linear-gradient(180deg, #C2E0FF -119.85%, #FFFFFF 100%)",
    border: "1px solid #C2E0FF",
    borderRadius: "10px",
    p: "2px",
    "& .MuiMenu-list": {
      p: 0,
      "& .MuiMenuItem-root": {
        p: "12px",
        borderBottom: "1px solid #D9E1E7",
        fontSize: { sm: "8px", md: "10px", lg: "14px" },
        lineHeight: "140%",
        color: "#667F93",
        borderRadius: "4px",
        "&:hover": {
          background: "#fff",
        },
        "&:last-child": {
          borderBottom: 0,
        },
        "& img": {
          mr: 1,
        },
      },
    },
  },
};

const DialogBody = {
  height: 'calc(100vh - 172px)',
  overflowY: 'auto'
}

const chats = {
  today: ["Supply Chain Management", "Supply Chain Operations"],
  yesterday: ["Impact of Global Events", "Trends of the Year", "Best Practices"],
  week: [
    "Navigating Supply Chain Challenges",
    "Innovations in Supply Chain Tech",
    "Recent Trends in Supply Chain",
  ],
};
export default function PromtsHistoryDrawer({
  open,
  onClose,
  conversationList,
  loadMore,
  setConversationList,
  fetchConversationId,
  handleNewChat,
  fetchConversations,
  onMyDashboardClick,
  setConversationId,
  setIsBookmarked,
  currentPage,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [, setSelectedItem] = useState("");
  const [openPinnedDialog, setOpenPinnedDialog] = useState(false);
  const [openBookmarkDialog, setOpenBookmarkDialog] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [chatData, setChatData] = useState(chats);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteItem] = useState("");
  const [editingId, setEditingId] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("UserInfo"))?.user_info,
    [],
  );
  const [loadingMore, setLoadingMore] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const openMenu = (e, chat) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
    setSelectedItem(chat.conversation_id);
    setSelectedId(chat.conversation_id);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSelectedItem("");
  };

  useEffect(() => {
    const grouped = {
      today: [],
      yesterday: [],
      week: [],
    };

    const today = dayjs().startOf("day");
    const yesterday = dayjs().subtract(1, "day").startOf("day");
    const sevenDaysAgo = dayjs().subtract(7, "day").startOf("day");

    conversationList.forEach((conv) => {
      const messageDate = dayjs(conv.latest_activity_timestamp).startOf("day");

      if (messageDate.isSame(today)) {
        grouped.today.push(conv);
      } else if (messageDate.isSame(yesterday)) {
        grouped.yesterday.push(conv);
      } else if (
        messageDate.isAfter(sevenDaysAgo) &&
        messageDate.isBefore(yesterday)
      ) {
        grouped.week.push(conv);
      }
    });

    setChatData(grouped);
  }, [conversationList]);

  const saveRename = async () => {
    if (!editValue.trim() || !editingId) return;

    const payload = {
      user_id: userInfo.id,
      user_name: userInfo.name,
      user_email: userInfo.email,
      conversation_id: editingId,
      conversation_title: editValue,
    };

    try {
      const res = await renameConversationV2(payload);
      const { conversation_id, conversation_title } = res.data;

      const updateSection = (list) =>
        list.map((c) =>
          c.conversation_id === conversation_id
            ? { ...c, conversation_title }
            : c,
        );

      setChatData((prev) => ({
        today: updateSection(prev.today),
        yesterday: updateSection(prev.yesterday),
        week: updateSection(prev.week),
      }));
      setConversationList((prev) =>
        prev.map((c) =>
          c.conversation_id === conversation_id
            ? { ...c, conversation_title }
            : c,
        ),
      );
      fetchConversations(currentPage, true);
      setSuccessMessage("Chat renamed successfully!");
      setSuccess(true);
      setEditingId(null);
    } catch (error) {
      console.error("Rename failed:", error);
      setError("Failed to rename title. Please try again.");
    }
  };

  const handleDeleteClick = () => {
    setOpenDeleteDialog(true);
    closeMenu();
  };

  const confirmDelete = async (selectedId) => {
    const payload = {
      user_id: userInfo.id,
      user_name: userInfo.name,
      user_email: userInfo.email,
      conversation_id: selectedId,
    };
    try {
      await deleteConversation(payload);
      setChatData((prev) => ({
        ...prev,
        today: prev.today.filter((c) => c.conversation_id !== selectedId),
        yesterday: prev.yesterday.filter(
          (c) => c.conversation_id !== selectedId,
        ),
        week: prev.week.filter((c) => c.conversation_id !== selectedId),
      }));
      fetchConversations(currentPage, true);
      setOpenDeleteDialog(false);
      handleNewChat();
      //  navigate("/samarth/chat", { replace: true });
      setSuccessMessage("Chat Deleted Successfully");
      setSuccess(true);
    } catch (error) {
      console.error("Failed to delete conversation:", error);
      setError("Unable to delete the conversation. Please try again.");
    }
  };
  const toggleBookmark = (id) => {
    const updateSection = (list) =>
      list.map((c) =>
        c.conversation_id === id
          ? { ...c, is_bookmarked: !c.is_bookmarked }
          : c,
      );

    setChatData((prev) => ({
      ...prev,
      today: updateSection(prev.today),
      yesterday: updateSection(prev.yesterday),
      week: updateSection(prev.week),
    }));
  };
  const handleBookmarkClick = (id) => {
    const allChats = [
      ...(chatData.today || []),
      ...(chatData.yesterday || []),
      ...(chatData.week || []),
    ];

    const selectedChat = allChats.find((c) => c.conversation_id === id);

    if (!selectedChat) return;

    const payload = {
      user_id: userInfo.id,
      user_name: userInfo.name,
      user_email: userInfo.email,
      conversation_id: id,
    };

    // ✅ Optimistic UI
    toggleBookmark(id);

    if (selectedChat.is_bookmarked) {
      // was true → now unbookmark
      unBookmarked(payload).catch(() => {
        toggleBookmark(id); // rollback
      });
    } else {
      // was false → now bookmark
      bookmarked(payload).catch(() => {
        toggleBookmark(id); // rollback
      });
    }
  };
  const renderChatSection = (title, chats) => {
    if (!chats?.length) return null;

    return (
      <>
        <Typography fontSize="12px" color="#94A3B8" mt={2} mb={0.5}>
          {title}
        </Typography>

        {chats.map((chat) => {
          const isEditing = editingId === chat.conversation_id;
          const isSelected = selectedId === chat.conversation_id && !isEditing;

          return (
            <Box
              key={chat.conversation_id}
              sx={{
                ...chatItemStyle,
                ...(isEditing && {
                  background: "#F0F7FF",
                  color: "#667F93",
                  "& .menuBtn": { opacity: 0 },
                }),
                ...(isSelected && {
                  background: "#F0F7FF",
                  color: "#0066CC",
                  "& .menuBtn": { opacity: 1 },
                }),
              }}
              onClick={() => {
                // navigate(`/samarth/chat/${chat.conversation_id}`);
                if (isEditing) return;
                fetchConversationId(chat.conversation_id, 1, true, {
                  showLoader: true,
                });
                setIsBookmarked(chat.is_bookmarked);
                setConversationId(chat.conversation_id);
                onClose();
              }}
            >
              {isEditing ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "end",
                    width: "100%",
                    border: "1px solid #D9E1E7",
                    borderRadius: "8px",
                    p: { sm: "6px 8px", md: "7px 10px", lg: "8px 12px" },
                    backgroundColor: "#fff",
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <TextField
                    fullWidth
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        saveRename();
                      }
                    }}
                    autoFocus
                    multiline
                    minRows={1}
                    maxRows={3}
                    placeholder="Enter Title..."
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        p: 0,
                        "& fieldset": { border: "none" },
                      },
                      "& .MuiInputBase-input": {
                        fontSize: { sm: "8px", md: "10px", lg: "14px" },
                        color: "#1A2025",
                        p: 0,
                      },
                    }}
                  />
                  <Typography
                    onClick={saveRename}
                    sx={{
                      fontSize: { sm: "8px", md: "10px", lg: "14px" },
                      fontWeight: 500,
                      color: "#0066CC",
                      cursor: "pointer",
                      whiteSpace: "nowrap",
                      ml: { sm: 0.2, md: 0.5, lg: 1 },
                      mt: { md: "1px", lg: "2px" },
                      "&:hover": { textDecoration: "underline" },
                    }}
                  >
                    Save
                  </Typography>
                </Box>
              ) : (
                <>
                  <Typography
                    sx={{
                      fontSize: { sm: "8px", md: "10px", lg: "14px" },
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "start",
                      width: "100%",
                    }}
                  >
                    {chat.conversation_title}
                  </Typography>

                  <IconButton
                    size="small"
                    className="menuBtn"
                    sx={{
                      opacity: 0,
                      transition: "0.2s",
                      padding: "0px !important",
                      margin: "0px !important",
                    }}
                    onClick={(e) => openMenu(e, chat)}
                  >
                    <Box
                      component="img"
                      src={MenuIcon}
                      sx={{ width: size, height: size }}
                    />
                  </IconButton>
                </>
              )}
            </Box>
          );
        })}
      </>
    );
  };
  const handleScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;

    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && !loadingMore) {
      setLoadingMore(true);
      await loadMore();
      setLoadingMore(false);
    }
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      BackdropProps={{
        invisible: true,
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", md: "48%", lg: "48%" },
          height: "calc(100vh - 50px)",
          top: "auto",
          bottom: 0,
          p: 2,
          backdropFilter: "blur(100.21739196777344px)",
          overflowX: "hidden",
          boxShadow: "0px 0px 20px 0px #0000001F",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb="8px"
      >
        <Typography fontWeight={600} fontSize={18}>
          Samarth AI
        </Typography>

        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          pb="12px"
          mb="12px"
          sx={{ borderBottom: "1px solid #DFDFDF" }}
        >
          <Box
            component="img"
            src={NoteIcon}
            sx={smallIconStyle}
            onClick={() => {
              handleNewChat();
              onClose();
            }}
          />
          <Box
            component="img"
            src={MinimizeIcon}
            sx={smallIconStyle}
            onClick={onClose}
          />
        </Box>
        <Box sx={DialogBody}>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={menuOptions}
            onClick={() => {
              onMyDashboardClick?.();
            }}
          >
            <Box
              component="img"
              src={DashboardIcon}
              sx={{ height: { xs: "14px", md: "16px", lg: "24px" } }}
            />
            <Typography sx={OptionLabel}>My Dashboard</Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            sx={menuOptions}
            onClick={() => setOpenPinnedDialog(true)}
          >
            <Box
              component="img"
              src={PinIcon}
              sx={{ height: { xs: "14px", md: "16px", lg: "24px" } }}
            />
            <Typography sx={OptionLabel}>Pinned Prompts</Typography>
          </Box>
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            justifyContent="space-between"
            sx={menuOptions}
            onClick={() => setOpenBookmarkDialog(true)}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                component="img"
                src={BookmarkIcon}
                sx={{ height: { xs: "14px", md: "16px", lg: "24px" } }}
              />
              <Typography sx={OptionLabel}>Bookmark Chats</Typography>
            </Box>
            <Tooltip
              title="Bookmarked chats stay saved for more than 7 days, unlike recent chats, and you can keep them for as long as you like."
              arrow
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [-120, 0],
                      },
                    },
                  ],
                },
                tooltip: {
                  sx: {
                    backgroundColor: "#1E293B",
                    color: "#667F93",
                    fontSize: { sm: "7px", md: "8px", lg: "12px" },
                    lineHeight: "140%",
                    px: { sm: 1, md: 1.25, lg: 1.5 },
                    py: { sm: 0.75, md: 0.9, lg: 1.5 },
                    borderRadius: "8px",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                    fontWeight: 400,
                  },
                },
                arrow: {
                  sx: {
                    color: "#fff",
                  },
                },
              }}
            >
              <IconButton size="small">
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ width: size, height: size }}
                />
              </IconButton>
            </Tooltip>
          </Box>

          <Accordion
            elevation={0}
            sx={recentChats}
            expanded={true}
            onChange={() => setExpanded(!expanded)}
          >
            <AccordionSummary>
              <Box display="flex" alignItems="center" gap={1}>
                <Box
                  component="img"
                  src={RecentIcon}
                  sx={{ height: { xs: "14px", md: "16px", lg: "24px" } }}
                />
                <Typography sx={OptionLabel}>Recent Chats</Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails sx={{ py: 0.5, px: 1 }}>
              <Box
                sx={{
                  maxHeight: {
                    sm: "calc(100vh - 350px)",
                    md: "calc(100vh - 380px)",
                    lg: "calc(100vh - 480px)",
                  },
                  overflowY: "auto",
                }}
                onScroll={handleScroll}
              >
                {chatData?.today?.length === 0 &&
                chatData?.yesterday?.length === 0 &&
                chatData?.week?.length === 0 ? (
                  <Typography
                    fontSize={{
                      sm: "8px",
                      md: "12px",
                      lg: "14px",
                    }}
                    color="#94A3B8"
                    textAlign="center"
                    py={2}
                  >
                    No Recent Chats Available
                  </Typography>
                ) : (
                  <>
                    {renderChatSection("Today", chatData?.today)}
                    {renderChatSection("Yesterday", chatData?.yesterday)}
                    {renderChatSection("Previous 7 Days", chatData?.week)}
                  </>
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Box>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
          sx={MenuStyles}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem
            onClick={() => {
              // setEditingItem(selectedItem);
              // setEditValue(selectedItem);
              setEditingId(selectedId);

              const allChats = [
                ...(chatData.today || []),
                ...(chatData.yesterday || []),
                ...(chatData.week || []),
              ];

              const selectedChat = allChats.find(
                (c) => c.conversation_id === selectedId,
              );

              setEditValue(selectedChat?.conversation_title || "");
              closeMenu();
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <EditIcon sx={{ width: size, height: size }} />
            </ListItemIcon>
            Rename
          </MenuItem>
          <MenuItem onClick={() => handleDeleteClick()}>
            <ListItemIcon>
              <Box
                component="img"
                src={DeleteIcon}
                alt="DeleteIcon"
                sx={{ width: size, height: size }}
              />
            </ListItemIcon>
            Delete
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleBookmarkClick(selectedId);
              closeMenu();
            }}
          >
            <ListItemIcon>
              <Box
                component="img"
                src={
                  [
                    ...(chatData.today || []),
                    ...(chatData.yesterday || []),
                    ...(chatData.week || []),
                  ].find((c) => c.conversation_id === selectedId)?.is_bookmarked
                    ? FilledBookmarkIcon
                    : BookmarkIcon
                }
                alt="BookmarkIcon"
                sx={{ width: size, height: size }}
              />
            </ListItemIcon>
            {[
              ...(chatData.today || []),
              ...(chatData.yesterday || []),
              ...(chatData.week || []),
            ].find((c) => c.conversation_id === selectedId)?.is_bookmarked
              ? "Bookmarked Chat"
              : "Bookmark Chat"}
          </MenuItem>
        </Menu>

        <PinnedPromptsDialog
          open={openPinnedDialog}
          onClose={() => setOpenPinnedDialog(false)}
          drawerClose={onClose}
          isState={true}
        />

        <BookmarkChatsDialog
          open={openBookmarkDialog}
          onClose={() => setOpenBookmarkDialog(false)}
          fetchConversations={fetchConversations}
          fetchConversationId={fetchConversationId}
          drawerClose={onClose}
          isState={true}
        />
        <DeleteChatDialog
          title="Are you sure you want to delete Chat?"
          description="This action cannot be undone."
          confirmText="Delete"
          cancelText="Cancel"
          open={openDeleteDialog}
          chatName={deleteItem}
          onClose={() => setOpenDeleteDialog(false)}
          onConfirm={() => confirmDelete(selectedId)}
        />
        <ReusableSnackbar
          open={success}
          message={successMessage}
          type="success"
          onClose={() => setSuccess(false)}
        />

        <ReusableSnackbar
          open={!!error}
          message={error}
          type="error"
          onClose={() => setError("")}
        />
      </Box>
    </Drawer>
  );
}